module.exports = __webpack_public_path__ + "img/klima.a4fff998.svg";